import PropTypes from 'prop-types';
import React from 'react';

import useCurrentUser from 'dpl/common/hooks/useCurrentUser';
import PlatformInfoLinks from 'dpl/nav_refresh/components/PlatformInfoLinks';
import SiteNavLinks from 'dpl/nav_refresh/components/SiteNavLinks';
import useInitialHeaderState from 'dpl/nav_refresh/hooks/useInitialHeaderState';
import MenuDrawer from 'dpl/search_result_filters/components/SearchResultsHeader/MenuDrawer';

import NavMenuBreedSearchContainer from '../containers/NavMenuBreedSearchContainer';
import BreederNavMenuOptions from './BreederNavMenuOptions';
import BuyerNavMenuOptions from './BuyerNavMenuOptions';
import MobileAuthButtons from './MobileAuthButtons';

export default function NavMenuDrawer({ onClose }) {
  const { user, isLoggedIn } = useCurrentUser();
  const { hasUnifiedMobileNav } = useInitialHeaderState();

  const isBreeder = user?.breeder ?? false;
  const isBuyer = user?.buyer ?? false;
  const firstName = user?.first_name;
  const greeting = firstName ? `Hi, ${firstName}!` : 'Menu';

  return (
    <MenuDrawer
      title={greeting}
      onClose={onClose}
      classes={{
        modal: 'NavMenuDrawer',
        header: 'b--none',
        content: 'flex-auto flex flex-column pv0',
        wrapper: 'flex-auto flex flex-column'
      }}
      maxWidth="100%"
    >
      <nav className="GlobalMobileMenuNavigationMenu ph5">
        {!isBreeder && hasUnifiedMobileNav && (
          <NavMenuBreedSearchContainer
            className="pv3"
            onParentClose={onClose}
          />
        )}
        {isLoggedIn && isBreeder && <BreederNavMenuOptions className="pb4" />}
        {isLoggedIn && isBuyer && (
          <BuyerNavMenuOptions className="bb b--default pb4" />
        )}
        {!isBreeder && <PlatformInfoLinks className="secondary" />}
        <SiteNavLinks className="bt b--default" />
      </nav>
      {!isLoggedIn && (
        <div className="flex-auto sticky flex items-end bottom-0">
          <MobileAuthButtons className="flex-auto font-16 bg-white bt b--default ph5 pv5" />
        </div>
      )}
    </MenuDrawer>
  );
}

NavMenuDrawer.propTypes = {
  onClose: PropTypes.func.isRequired
};
